import { AnchorNode } from './AnchorNode';
import { Settings } from './config';

const findIndexOfNode = (node: Node, list: Node[], max: number) => {
    for (node = node.parentNode; node; node = node.parentNode) {
        for (let i = 0; i < max; i++) {
            if (list[i] === node) { return i; }
        }
    }
    return -1;
};

export const getAnchorFromDocument = () => {
    const nodes = Array.from(document.querySelectorAll(Settings.selectorStructure));
    const entries: AnchorNode[] = [];
    const result: AnchorNode[] = [];
    for (let i = 0, ii = nodes.length; i < ii; i++) {
        const idxParent = findIndexOfNode(nodes[i], nodes, i);
        const parent = idxParent === -1 ? null : entries[idxParent];
        const current = new AnchorNode(parent, nodes[i], []);
        if (current.parent) {
            current.parent.children.push(current);
            entries.push(current);
        } else {
            result.push(current);
            entries.push(current);
        }
    }
    if (result.length > 1) {
        // tslint:disable-next-line:no-console
        console.warn(`[NoteService] searchNodes result > 1`);
    }
    return result[0];
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/anchor/getAnchorFromDocument.tsx